import {
  loginFailure,
  loginStart,
  loginSuccess,
  registerFailure,
  registerStart,
  registerSuccess,
} from "./userRedux";
import { publicRequest } from "../request";

export const login = async (dispatch, user) => {
  dispatch(loginStart());

  try {
    const res = await publicRequest.post("/auth/login", user);
    dispatch(loginSuccess(res.data));
  } catch (err) {
    console.log(err.response.data.message);
    dispatch(loginFailure(err.response.data.message));
  }
};

export const register = async (dispatch, user) => {
  dispatch(registerStart());

  try {
    const res = await publicRequest.put("/auth/register", user);
    // console.log(res.data);
    dispatch(registerSuccess(res.data));
  } catch (err) {
    console.log(err.response.data.message);
    dispatch(registerFailure(err.response.data.message));
  }
};
